import {
  endOfMonth,
  endOfYear,
  startOfMonth,
  startOfQuarter,
  startOfYear,
  subMonths,
} from 'date-fns';

import { DatePickerViewMode } from 'components/_core/SunshineDatePicker';

export type Interval = {
  from: Date;
  to: Date;
};

export type RangeIntervalTypes = 'month' | 'quarter' | 'year' | 'custom';

export type RangeIntervalDate = {
  previousInterval: Interval | null;
  currentInterval: Interval;
  type: RangeIntervalTypes;
};

export type Option<T> = {
  label: string;
  value: T;
};

export const getDefaultMonthlyValue = (): RangeIntervalDate => {
  const today = new Date();
  const lastMonth = subMonths(today, 1);

  return {
    currentInterval: {
      from: startOfMonth(today),
      to: endOfMonth(today),
    },
    previousInterval: {
      from: startOfMonth(lastMonth),
      to: endOfMonth(lastMonth),
    },
    type: 'month',
  };
};

export const getDefaultYearlyValue = (): RangeIntervalDate => {
  const today = new Date();
  return {
    currentInterval: {
      from: startOfYear(today),
      to: endOfYear(today),
    },
    previousInterval: null,
    type: 'year',
  };
};

export const getDefaultSelectedDate = (period: DatePickerViewMode): Date => {
  const today = new Date();

  switch (period) {
    case 'month':
      return startOfMonth(today);
    case 'year':
      return startOfYear(today);
    case 'quarter':
      return startOfQuarter(today);
    default:
      return startOfMonth(today);
  }
};
